import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { ILiftNewsFeedClicks } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/client-api/lift_news_feed_clicks';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  limit: 999,
};
const defaultGetSingleFilters: IQueryCommandOptions = {};
// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ILiftNewsFeedClicks>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'lift_news_feed_clicks/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
